import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, exhaustMap, map, of } from 'rxjs';
import {
  loadAllProductTypes,
  loadProductTypesBySearchRequest,
  loadProductTypesFailure,
  loadProductTypesSuccess,
} from './product-types.actions';
import { ProductTypesService } from './product-types.service';
import { ApiService } from 'src/app/services/api.service';
import { ProductTypeSearchRequest, ProductTypeSearchResponse } from 'src/app/models/viewmodels';

@Injectable()
export class ProductTypesEffects {
  loadAllProductTypes$ = createEffect(() => {
      return this.actions$.pipe(
        ofType(loadAllProductTypes),
        exhaustMap(() =>
          this.productTypesService.getAll().pipe(
            map((productTypes) =>
              loadProductTypesSuccess({ productTypes })
            ),
            catchError((error) =>
              of(loadProductTypesFailure({ error }))
            )
          )
        )
      )
    }
  );
   loadAllProductsTypesBySearchRequest$ = createEffect(() => {
        return this.actions$.pipe(
          ofType(loadProductTypesBySearchRequest),
          //withLatestFrom(this.store.select(selectProductSearchRequest)),
          exhaustMap(({productTypeSearchRequest} ) => {
            return this.apiService.post<ProductTypeSearchRequest, ProductTypeSearchResponse>('productType/search', productTypeSearchRequest)
              .pipe(
                  map((productTypeSearchResponse) => {
                      return loadProductTypesSuccess({ productTypes: productTypeSearchResponse.productTypes })
                    }
                  ),
                  catchError((error) =>
                    of(loadProductTypesFailure({ error }))
                  )
              );
  
          }
          )
        )
      }
    );
  

  constructor(private actions$: Actions, private productTypesService: ProductTypesService, private apiService: ApiService) {
  }
}
